var chunkToChildrenMap = {
	"210": [
		315
	],
	"360": [
		571
	],
	"516": [
		169
	],
	"591": [
		412
	],
	"791": [
		658
	],
	"944": [
		286
	],
	"994": [
		571,
		498
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));